import { fcCapsuleSet } from '@seeqdev/icons/seeq';

export enum BinMode {
  SIZE = 'size',
  NUMBER = 'number',
}

export enum ControlChartType {
  IMR = 'IndividualsMovingRangeChart',
  XBARR = 'AverageRangeChart',
  XBARS = 'AverageStdDevChart',
}

export enum RunRules {
  WE1 = 'WE1',
  WE2 = 'WE2',
  WE3 = 'WE3',
  WE4 = 'WE4',
}

export const ALIGN_WEEKLY_ID = 'weekly';
export const MAX_UI_BINS = 25;
export const MIN_NUMBER_OF_BINS = 1;
export const DEFAULT_NUMBER_OF_BINS = 10;
export const MAX_BACKEND_BINS = 1000;
export const DEFAULT_BIN_WIDTH = 1;
export const DEFAULT_BIN_WIDTH_UOM = '';
export const MIN_SIZE_OF_BIN = 0;
export const DEFAULT_RATIONAL_SUBGROUP_SIZE = 1;
export const MIN_RATIONAL_SUBGROUP_SIZE = 1;
export const MIN_RATIONAL_SUBGROUP_SIZE_FOR_XBARS = 10;
export const MAX_RATIONAL_SUBGROUP_SIZE = 25;
export const MIN_SUBGROUP_SIZE = 2;

export const DEFAULT_ALIGNMENT_OPTION = {
  id: ALIGN_WEEKLY_ID,
  itemType: 'conditionDisplayType',
  name: 'Weekly',
};

/**
 * The alignment condition is written into the worksheet's dehydrated state as-is, and `sanitizeToolItem`
 * keeps an icon off every other item that reaches that state. So the icon belongs only where the option is
 * offered for selection, which is also where the selected row reads its own icon from.
 */
export const DEFAULT_ALIGNMENT_SELECT_OPTION = { ...DEFAULT_ALIGNMENT_OPTION, icon: fcCapsuleSet };

export const CONTROL_CHART_OPTIONS = [
  { value: ControlChartType.IMR, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.CONTROL_CHART.IMR' },
  { value: ControlChartType.XBARR, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.CONTROL_CHART.XBAR_R' },
  { value: ControlChartType.XBARS, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.CONTROL_CHART.XBAR_S' },
];

export const RUN_RULES_OPTIONS = [
  { value: RunRules.WE1, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.RUN_RULES.WE1' },
  { value: RunRules.WE2, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.RUN_RULES.WE2' },
  { value: RunRules.WE3, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.RUN_RULES.WE3' },
  { value: RunRules.WE4, label: 'INVESTIGATE_TOOLS.STATISTICS_SUMMARY.RUN_RULES.WE4' },
];
